<template>
    <div class="grid-button-section action-buttons">
        <b-button-group>
            <b-button v-for="button in visibleButtons" :key="button.key"
                      size="sm"
                      :variant="button.variant"
                      :disabled="button.disabled"
                      :type="button.type || 'button'"
                      :href="button.href"
                      :target="button.href ? '_blank' : null"
                      :aria-label="button.ariaLabel || button.title"
                      :data-test="button.dataTest || ('btn-action-' + button.key)"
                      v-b-popover.hover.top.noninteractive="actionHoverPop(button.title)"
                      @click="onClick(button)">
                <i :class="button.icon"></i>
            </b-button>
        </b-button-group>
    </div>
</template>

<script>
    export default {
        name: 'grid-button-section',
        props: {
            buttons: {
                type: Array,
                default: () => []
            }
        },
        computed: {
            visibleButtons() {
                return this.buttons.filter(button => button.visible !== false);
            }
        },
        methods: {
            actionHoverPop(title) {
                return {
                    title,
                    container: "body",
                    offset: "0, 8",
                    customClass: "action-hover-pop",
                    boundary: "window",
                    delay: { show: 300, hide: 0 }
                };
            },
            onClick(button) {
                if (button.disabled)
                    return;
                this.$emit('action', button.key);
            }
        }
    };
</script>

<style scoped>
    .grid-button-section {
        display: inline-flex;
        white-space: nowrap;
    }
    .grid-button-section ::v-deep .btn-group {
        flex-wrap: nowrap;
    }
    .grid-button-section ::v-deep .btn {
        margin: 0;
    }
</style>
